import ApplicationComponent from "legacy/ApplicationComponent"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import InsuranceForm from "legacy/contract-quote/InsuranceForm"
import RegistrationForm from "legacy/contract-quote/RegistrationForm"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class InquiryInsuranceAndRegistrationForm extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      insurance: this.props.insurance,
      registration: this.props.registration,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.props.handleInsuranceRegistration(
        this.state.insurance,
        this.state.registration
      )
    }
  }

  renderRegistrationForm() {
    if (this.props.registrationRequirement !== "none") {
      return (
        <RegistrationForm
          registration={this.state.registration}
          validator={this.validator}
          setParentState={this.handleInputChange}
        />
      )
    }
  }

  renderInsuranceForm() {
    if (this.props.insuranceRequirement !== "none") {
      return (
        <InsuranceForm
          insurance={this.state.insurance}
          validator={this.validator}
          setParentState={this.handleInputChange}
        />
      )
    }
  }

  render() {
    return (
      <div>
        {this.renderInsuranceForm()}
        {this.renderRegistrationForm()}
        <NextButton
          click={this.finish.bind(this)}
          icon=""
          text="Continue"
          btnClass="btn btn-primary w-full"
        />
      </div>
    )
  }
}

InquiryInsuranceAndRegistrationForm.propTypes = {
  insurance: PropTypes.object,
  registration: PropTypes.object,
  handleInsuranceRegistration: PropTypes.func.isRequired,
  registrationRequirement: PropTypes.string,
  insuranceRequirement: PropTypes.string,
}

export default InquiryInsuranceAndRegistrationForm
